// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideUser as RawLucideUser } from "lucide-react";
export const LucideUser = /* @__PURE__ */ createIcon(RawLucideUser, "LucideUser", 2);
